import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const GuestDashboard = () => {
    const [meetId, setMeetId] = useState('');
    const navigate = useNavigate();

    const handleJoinMeeting = (e) => {
        e.preventDefault();
        if (meetId.trim()) {
            navigate(`/meet/${meetId.trim()}`);
        }
    };

    const styles = {
        container: { padding: '2rem', maxWidth: '600px', margin: 'auto', textAlign: 'center' },
        input: { padding: '0.8rem', width: '80%', margin: '1rem 0', borderRadius: '5px', border: '1px solid #ccc', fontSize: '1rem' },
        button: { padding: '0.8rem 1.5rem', cursor: 'pointer', border: 'none', borderRadius: '5px', color: 'white', background: '#2563EB', fontSize: '1rem' },
    };

    return (
        <div style={styles.container}>
            <h1>Welcome to ichrahly meet</h1>
            <p>Enter a Meeting ID to join as a guest or log in to create a meeting.</p>
            
            <form onSubmit={handleJoinMeeting} aria-label="Join Meeting Form">
                <label htmlFor="meetIdInput" style={{ display: 'none' }}>Meeting ID</label>
                <input
                    id="meetIdInput"
                    type="text"
                    value={meetId}
                    onChange={(e) => setMeetId(e.target.value)}
                    placeholder="Enter Meeting ID"
                    style={styles.input}
                    required
                />
                <button type="submit" style={styles.button}>
                    Join
                </button>
            </form>
        </div>
    );
};

export default GuestDashboard;
